import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Button.styl';
import Checkmark from '-!svg-react-loader!../../assets/check-mark.svg';
/* eslint import/no-webpack-loader-syntax: off */

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };

    this.toggleHover = this.toggleHover.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  toggleHover = () => {
    if (!this.props.disabled) {
      this.setState({
        hover: !this.state.hover
      });
    }
  };

  handleClick = () => {
    if (this.props.setContactType) {
      this.props.setContactType(this.props.type);
    }
    if (this.props.setSelectedMembers) {
      this.props.setSelectedMembers(this.props.index, this.props.memberID);
    }
    if (this.props.clearSelectedMembers) {
      this.props.clearSelectedMembers();
    }
    if (this.props.sendEmail) {
      this.props.sendEmail(this.props.emailInfo);
    }
    if (this.props.doneCalling) {
      this.props.doneCalling();
    }
    if (this.props.scrollTop) {
      this.props.scrollTop();
    }
  };

  render() {
    let baseStyle = {
      borderColor: this.props.color,
      cursor: this.state.hover ? 'pointer' : 'default'//,
      //textTransform: this.props.capitalize ? 'capitalize' : 'uppercase'
    };
    let originalButtonStyles = {
      color: this.state.hover ? '#fff' : this.props.color,
      backgroundColor: this.state.hover ? this.props.color : '#fff'
    };

    let invertedButton = {
      color: this.state.hover ? this.props.color : '#fff',
      backgroundColor: this.state.hover ? '#fff' : this.props.color
    };

    let buttonStyles = this.props.inverted
      ? Object.assign({}, baseStyle, invertedButton)
      : Object.assign({}, baseStyle, originalButtonStyles);

    return (
      <button
        className={styles.button}
        //style={buttonStyles}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        onClick={this.handleClick}
        disabled={this.props.disabled}
      >
        {this.props.completed
          ? <div
              className={styles.checkmark}
              style={{ backgroundColor: this.props.color }}
            >
              <Checkmark width={20} height={20} />
            </div>
          : ''}
        {this.props.title}
      </button>
    );
  }
}

Button.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  type: PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/Button.js